import React, { useEffect, useState } from 'react'
import { uid } from '@zera-admin/utils'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Button, { ButtonGroup, LinkButton } from '@zera-admin/button'
import Page, { PageHeader, Container } from '@zera-admin/page'

import { useFlagcardContext } from 'app/contexts/flagcard'
import { ValidationError } from 'app/shared/types'
import MainLayout from 'layouts/main'
import namedEntityControlSetsService, {
  NamedEntityControlSet,
  UpdateNamedEntityControlSetRequest,
} from 'services/http/dataset/named-entity-control-set'

import { UpdateNamedEntityControlSetProps } from './types'
import NamedEntityControlSetForm from './NamedEntityControlSetForm'

const UpdateNamedEntityControlSet: React.FunctionComponent<UpdateNamedEntityControlSetProps> =
  ({ match, history }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isReady, setIsReady] = useState(true)
    const [namedEntityControlSet, setNamedEntityControlSet] =
      useState<NamedEntityControlSet>()
    const [flagcard] = useFlagcardContext()

    useEffect(() => {
      const id = parseInt(match.params.id)

      namedEntityControlSetsService
        .getById(id)
        .then((res) => {
          setNamedEntityControlSet(res.data)
        })
        .catch((err: Error) => {
          console.log(err)
        })
        .finally(() => {
          setIsReady(false)
        })
    }, [match.params.id, history])

    const handleSubmit = (data: UpdateNamedEntityControlSetRequest) => {
      if (data) {
        setIsLoading(true)

        namedEntityControlSetsService
          .update(data)
          .then(() => {
            flagcard.add({
              id: uid(),
              appearance: 'success',
              title: 'İşlem Başarılı',
              children:
                'Geçerli veri, sistem üzerinde başarıyla güncellenmiştir.',
            })
          })
          .catch((error) => {
            console.log(error)

            flagcard.add({
              id: uid(),
              appearance: 'error',
              title: 'Hata Oluştu',
              children:
                'Geçerli veri güncellenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
          .finally(() => {
            setIsLoading(false)
          })
      }
    }

    const handleError = (error?: ValidationError) => {
      console.log(error)
    }

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem
          text="İsimlendirilmiş varlık kontrol setleri"
          href="/named-entity-control-set"
        />
        <BreadcrumbItem text="Cinsiyet kontrol seti güncelle" />
      </Breadcrumb>
    )

    return (
      <MainLayout isLoading={isReady}>
        <Container width="medium">
          <Page>
            <PageHeader
              // actions={<Button appearance="error">Delete user</Button>}
              breadcrumbs={breadcrumbs}
              bottomBar={
                <p>
                  Aşağıdaki bilgileri doldurarak geçerli isimlendirilmiş varlık
                  kontrol setini güncelleyebilirsiniz.
                </p>
              }
            >
              Veri güncelleniyor:
              {namedEntityControlSet ? namedEntityControlSet.text : null}
            </PageHeader>
            <NamedEntityControlSetForm
              actions={
                <ButtonGroup>
                  <Button
                    appearance="primary"
                    children="Güncelle"
                    isLoading={isLoading}
                    type="submit"
                  />
                  <LinkButton href="/named-entity-control-set">
                    İptal
                  </LinkButton>
                </ButtonGroup>
              }
              operation="update"
              onSubmit={handleSubmit}
              onError={handleError}
              values={namedEntityControlSet}
            />
          </Page>
        </Container>
      </MainLayout>
    )
  }

export default UpdateNamedEntityControlSet
